import { useState } from 'react'
import useSWRMutation from 'swr/mutation'
import { CustomModal } from '../CustomModal'
import { ConfirmationModal } from '../ConfirmationModal'
import { ConfirmationProps, SucessOrFailModal } from '../SucessOrFailModal'
import { MailingTermsModalContent } from './MailingTermsModalContent'
import { useMailingExport } from '../../hooks/mailing-export'
import { EventOptionCard } from '../EventOptionCard'
import cardMailing from '../../assets/event-options/card-mailing.svg'

const defaultConfirmationMsg: ConfirmationProps = {
  customSuccess: {
    title: 'Download iniciado com sucesso',
    subtitle: 'O arquivo da base de mailing foi gerado.',
  },
  customError: {
    title: 'Não foi possível gerar o arquivo',
    subtitle: 'Tente novamente.',
  },
}

interface MailingDownloadButtonProps {
  eventId: string | undefined
}

export const MailingDownloadButton = ({
  eventId,
}: MailingDownloadButtonProps) => {
  const [isTermModalOpen, setIsTermModalOpen] = useState<boolean>(false)
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false)
  const [is2faOpen, setIs2faOpen] = useState<boolean>(false)
  const [code2fa, setCode2fa] = useState<string>('')
  const [isConfirmationOpen, setIsConfirmationOpen] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null)
  const [confirmationMsg, setConfirmationMsg] = useState<ConfirmationProps>(
    defaultConfirmationMsg
  )

  const { mailingExportFetcher } = useMailingExport(
    eventId,
    termsAccepted,
    code2fa
  )
  const { trigger: exportTrigger }: any = useSWRMutation(
    'useMailingExportSWR',
    mailingExportFetcher,
    { revalidate: false }
  )

  const handleOpenTerms = () => {
    setTermsAccepted(false)
    setIsTermModalOpen(true)
  }

  const handleCancelTerms = () => {
    setIsTermModalOpen(false)
    setTermsAccepted(false)
  }

  const handleConfirmTerms = () => {
    if (!termsAccepted) return
    setIsTermModalOpen(false)
    setIs2faOpen(true)
  }

  return (
    <>
      <EventOptionCard
        title="Base de mailing"
        description="Baixe a base de contatos dos compradores"
        iconSrc={cardMailing}
        onClick={handleOpenTerms}
      />

      <CustomModal isOpen={isTermModalOpen} onRequestClose={handleCancelTerms}>
        <MailingTermsModalContent
          accepted={termsAccepted}
          setAccepted={setTermsAccepted}
          onCancel={handleCancelTerms}
          onConfirm={handleConfirmTerms}
        />
      </CustomModal>

      <ConfirmationModal
        isOpen={is2faOpen}
        setIsOpen={setIs2faOpen}
        setCode={setCode2fa}
        setIsSuccess={setIsSuccess}
        setConfirmationMsg={setConfirmationMsg}
        setIsConfirmationOpen={setIsConfirmationOpen}
        submitResponse={exportTrigger}
        submitLabel="Confirmar download"
        skip2faPreValidation
        onRequestClose={() => setIs2faOpen(false)}
      />

      <SucessOrFailModal
        isOpen={isConfirmationOpen}
        isSuccess={isSuccess}
        setIsOpen={setIsConfirmationOpen}
        customSuccess={confirmationMsg.customSuccess}
        customError={confirmationMsg.customError}
        rollBackUrl={`/events/${eventId}`}
      />
    </>
  )
}

export default MailingDownloadButton
